import { axios, Response } from '../../index'
import { GetFavoriteTaskResponse } from './responses/get-favorite-task-response'

const getFavoriteTasks = (): Response<GetFavoriteTaskResponse[]> => {
  return axios.get('/v1/favorites/favorites-tasks')
}

export default getFavoriteTasks
